// 引入vue
import Vue from 'vue';
// 引入路由
import Router from 'vue-router';
// 通过vue使用路由
Vue.use(Router);

//定义路由
const routes = [
    //home路由：主页
    {
        path: "/home", 
        //对应这一个路径，应该加载的路由组件
        //箭头函数的形式时懒加载，也就是软件打开时，暂时先不加载这一路由
        // 等要用到这一路由时再加载，这样，虽然路由跳转速度较慢，但可以
        // 减少首屏加载时间，提升用户体验
        // 如果在一个文件夹内，其vue文件是被命名为index.vue, 
        // 那么引入路径时就引入到该文件夹的路径就好。这样，vue就好像当作你时引入的Home.vue一样
        component: () => import('@/views/Home')
    },

    {
        //路由的路径, '/'的意义是路径没有时就是它
        path: "/",
        // redirect是重定向，打开软件默认就让它直接重定向到home
        redirect: "/home"
    },

    // register路由：注册
    {
        path: "/register",
        component: () => import('@/views/Register')
    },

    // register路由：记录
    {
        path: "/records",
        component: () => import('@/views/Records')
    },

    // register路由：消息
    {
        path: "/message",
        component: () => import('@/views/Message')
    },

    // 首页路由：我的
    {
        path: "/profile",
        component: () => import('@/views/Profile')
    },

    // addresses路由：收货地址
    {
        path: "/addresses",
        component: () => import('@/views/Addresses')
    },

    // productDetail路由: 展示商品详情
    {
        path: "/productDetails",
        component: () => import('@/views/ProductDetails')
    },

    // like路由: 展示当前用户喜欢的商品
    {
        path: "/like",
        component: () => import('@/views/Like')
    },

    // cart路由: 展示被当前用户加入购物车的商品
    {
        path: "/cart",
        component: () => import('@/views/Cart')
    },

    // decideToOrder路由: 展示当前商品被用户下单的相关信息
    {
        path: "/decideToOrder",
        component: () => import('@/views/DecideToOrder')
    },

    // bannerDetail路由: 展示当前商品被用户下单的相关信息
    {
        path: "/bannerDetail",
        component: () => import('@/views/BannerDetail')
    },

    // remainedTargetProducts路由: 展示当前商品被用户下单的相关信息
    {
        path: "/remainedTargetProducts",
        component: () => import('@/views/RemainedTargetProducts')
    },

    // search路由: 展示当前商品被用户下单的相关信息
    {
        path: "/search",
        component: () => import('@/views/Search')
    }
];

export default new Router({
    mode: 'history', // 或 'hash'
    routes,
});